import React from 'react';
import SimpleSideMenuTemplate from '../templates/SimpleSideMenuTemplate';
const CMSMenuNotAvailable = () => {
  return /*#__PURE__*/React.createElement(SimpleSideMenuTemplate, {
    title: `Menù non disponibile`,
    description: `Non è possibile modificare questo componente.`,
    classes: {
      root: 'not-available'
    }
  });
};
export default CMSMenuNotAvailable;